var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ArrowComponent } from './arrow.component';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
var TAPArrowComponent = /** @class */ (function (_super) {
    __extends(TAPArrowComponent, _super);
    function TAPArrowComponent(ibeAdminService) {
        var _this = _super.call(this) || this;
        _this.ibeAdminService = ibeAdminService;
        _this.stops = [];
        _this.commercialStops = [];
        _this.allStops = [];
        return _this;
    }
    TAPArrowComponent.prototype.ngOnInit = function () {
    };
    /**
     * Return flight arrow classes
     */
    TAPArrowComponent.prototype.INDRA_printArrowStyles = function () {
        return {
            // 'has-stopover': this.legs === 'layover',
            'has-stopover': true,
            'show-small-dots': this.stops.length > 2
        };
    };
    /**
     * Check if flight has stops
     */
    TAPArrowComponent.prototype.INDRA_hasStops = function () {
        return this.stops;
    };
    TAPArrowComponent.prototype.INDRA_hasCommercialStops = function () {
        return this.commercialStops;
    };
    TAPArrowComponent.prototype.INDRA_hasAllStops = function () {
        return this.allStops;
    };
    TAPArrowComponent.prototype.getLocation = function (stop) {
        if ((stop.stopTime > 0 && !stop.stopover) && (stop.technicalStops != null)) {
            var totalMin = stop.stopTime;
            var hours = Math.floor(totalMin / 60);
            var min = totalMin % 60;
            return stop.arrivalAirport + " " + this.ibeAdminService.getTranslationValue('bookingDetails.alt.stopfor') + " " + hours + "h" + min + "min | " + this.ibeAdminService.getTranslationValue('bookingDetails.text.commercialStopIn') + " " + stop.technicalStops[0].location;
        }
        else if (stop.stopTime > 0 && !stop.stopover) {
            var totalMin = stop.stopTime;
            var hours = Math.floor(totalMin / 60);
            var min = totalMin % 60;
            // Note: Workaround for now to handle to scenario/basis for determining stop tooltip (TODO update)
            if (stop.airport && stop.airport.location) {
                return stop.airport.location.city;
            }
            else if (stop.arrivalAirport) {
                return stop.arrivalAirport + " " + this.ibeAdminService.getTranslationValue('bookingDetails.alt.stopfor') + " " + hours + "h" + min + "min";
            }
        }
        else if (stop.technicalStops.length > 0) {
            var totalMin = stop.technicalStops[0].duration;
            var hours = Math.floor(totalMin / 60);
            var min = totalMin % 60;
            return stop.technicalStops[0].location + " " + this.ibeAdminService.getTranslationValue('bookingDetails.alt.stopfor') + " " + hours + "h" + min + "min";
        }
        return '';
    };
    return TAPArrowComponent;
}(ArrowComponent));
export { TAPArrowComponent };
